/* eslint-disable no-undef */
import React, { useImperativeHandle, forwardRef, useRef, useEffect } from 'react'

import { noop } from 'lodash'
import { ketcherHost, ketcherUrl } from 'config'

const KETCHER_ACTION_SET_SMILES = 'setSmiles'
const KETCHER_ACTION_GET_SMILES = 'getSmiles'
const KETCHER_ACTION_CLEAR_ALL_SMILES = 'clear'

const MoleculeSketcher = (props, ref) => {
  const iframeRef = useRef()

  const getKetcherMessage = (action, data) => {
    switch (action) {
      case KETCHER_ACTION_SET_SMILES:
        return '{"command":"setSmiles","smiles":"' + data + '"}'
      case KETCHER_ACTION_GET_SMILES:
        return '{"command":"getSmiles"}'
      case KETCHER_ACTION_CLEAR_ALL_SMILES:
        return '{"command":"clear"}'
      default:
        console.log('unknown action ', action)
    }
  }

  useEffect(() => {
    const onMessage = (event) => {
      if (event?.origin === ketcherHost) {
        props.onChange?.(event?.data)
      }
    }
    window.addEventListener('message', onMessage, false)
    return () => {
      window.removeEventListener('message', onMessage)
    }
  }, [])

  const getSmiles = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const contentWindow = iframeRef.current?.contentWindow

        window.removeEventListener('message', noop)
        window.addEventListener(
          'message',
          (event) => {
            if (event?.origin === ketcherHost) {
              resolve(event?.data)
            }
          },
          false
        )

        // Safely enables cross-origin communication between Window objects
        // (https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage)
        contentWindow.postMessage(
          getKetcherMessage(KETCHER_ACTION_GET_SMILES),
          ketcherUrl
        )
      } catch (error) {
        console.log('error: ', error)
        reject(error)
      }
    })
  }

  const setSmiles = (smiles) => {
    const contentWindow = iframeRef.current?.contentWindow
    contentWindow.postMessage(
      getKetcherMessage(KETCHER_ACTION_SET_SMILES, smiles),
      ketcherUrl
    )
  }

  const clearSmiles = () => {
    const contentWindow = iframeRef.current?.contentWindow
    contentWindow.postMessage(
      getKetcherMessage(KETCHER_ACTION_CLEAR_ALL_SMILES),
      ketcherUrl
    )
  }

  useImperativeHandle(
    ref,
    () => ({
      getSmiles,
      setSmiles,
      clearSmiles,
    }),
    []
  )
  const onIframeRef = (node) => {
    if (!node) {
      return
    }
    try {
      node.contentWindow.addEventListener('load', () => {
        setIsLoaded(true)
      })

      iframeRef.current = node
    } catch (error) {
      // console.log(error)
    }
  }

  return (
    <div style={{ width: props.width }}>
      <iframe
        title={'Molecule Sketcher'}
        ref={onIframeRef}
        src={ketcherUrl}
        width="100%"
        height="500"
        frameBorder="0"
      />
    </div>
  )
}

export default forwardRef(MoleculeSketcher)
